module.exports = __webpack_public_path__ + "static/img/55.2ffdc00.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Microsoft365Security/55.png
// module id = XLrF
// module chunks = 1